import React, { useState, useEffect } from "react";
import MainCalculatorsList from "../FoodCalculator/MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice Crêpes Parfaites - Comment Faire Crêpes Moelleuses et Délicieuses";
const DESCRIPTION =
  "Calculatrice Crêpes Parfaites - Comment Faire Crêpes Moelleuses et Délicieuses pour adapter vos recettes, portions et conversions en cuisine. Resultat rapide et pratique pour cuisiner avec plus de precision chaque jour.";
const KEYWORDS =
  "crêpes parfaites faire crêpes moelleuses et délicieuses, calculatrice crêpes parfaites faire crêpes moelleuses et délicieuses, calcul en ligne, cuisine, recette, conversion, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/perfect-pancake/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Calculatrice Crêpes Parfaites",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
];

function PerfectPancakeCalculator() {
  const [pancakeCount, setPancakeCount] = useState(8);
  const [pancakeSize, setPancakeSize] = useState(10);
  const [pancakeThickness, setPancakeThickness] = useState(1);
  const [servingSize, setServingSize] = useState(2);

  const [result, setResult] = useState(null);

  const calculateIngredients = () => {
    const radius = pancakeSize / 2;
    const volumePerPancake = Math.PI * Math.pow(radius, 2) * pancakeThickness;

    const referenceVolume = Math.PI * Math.pow(5, 2) * 1;
    const scaleFactor = (volumePerPancake / referenceVolume) * pancakeCount;

    const flour = 62.5 * scaleFactor;
    const milk = 90 * scaleFactor;
    const eggs = 0.5 * scaleFactor;
    const butter = 7.5 * scaleFactor;
    const sugar = 5 * scaleFactor;
    const bakingPowder = 3 * scaleFactor;
    const salt = 0.5 * scaleFactor;

    setResult({
      flour,
      milk,
      eggs: Math.ceil(eggs * 10) / 10,
      butter,
      sugar,
      bakingPowder,
      salt,
      totalVolume: volumePerPancake * pancakeCount,
      peopleServed: Math.floor(pancakeCount / servingSize)
    });
  };

  useEffect(() => {
    calculateIngredients();
  }, [pancakeCount, pancakeSize, pancakeThickness, servingSize]);

  const handleClear = () => {
    setPancakeCount(8);
    setPancakeSize(10);
    setPancakeThickness(1);
    setServingSize(2);
    setResult(null);
  };

  return (
    <div className="ltr" style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>Calculatrice Crêpes Parfaites</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                La <strong>calculatrice crêpes parfaites</strong> you aide à déterminer les proportions exactes pour préparer des crêpes en fonction du nombre désiré et de leur taille. Que vous prépariez le petit-déjeuner pour deux ou un brunch pour la famille, cet outil garantit un équilibre parfait entre farine, lait et œufs.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Spécifiez Détails des Crêpes</h2>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label >Nombre Crêpes Désiré</label>
                  <input
                    type="number"
                    className="form-control"
                    value={pancakeCount}
                    onChange={(e) => setPancakeCount(parseFloat(e.target.value) || 0)}
                    min="1"
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label >Diamètre Crêpe (cm)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={pancakeSize}
                    onChange={(e) => setPancakeSize(parseFloat(e.target.value) || 0)}
                    min="1"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-12 col-md-6">
                  <label >Épaisseur Crêpe (cm)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={pancakeThickness}
                    onChange={(e) => setPancakeThickness(parseFloat(e.target.value) || 0)}
                    min="0.1"
                    step="0.1"
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label >Crêpes par Personne ?</label>
                  <input
                    type="number"
                    className="form-control"
                    value={servingSize}
                    onChange={(e) => setServingSize(parseFloat(e.target.value) || 1)}
                    min="1"
                  />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleClear}
                  className="btn btn-secondary"
                  style={{ fontSize: "16px", padding: "10px 30px" }}
                >
                  Réinitialiser
                </button>
              </div>

              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>Ingrédients Requis :</strong>
                  </h3>
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Ingrédient</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Quantité</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>Farine (Blé)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.flour.toFixed(1)} g</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Lait</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.milk.toFixed(1)} ml</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Œufs</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.eggs}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Beurre Fondu</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.butter.toFixed(1)} g</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Sucre</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.sugar.toFixed(1)} g</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Poudre Cuisson</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.bakingPowder.toFixed(1)} g</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Sel</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.salt.toFixed(1)} g</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Résumé Portion</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          <li>🥞 <strong>Total Crêpes :</strong> {pancakeCount}</li>
                          <li>👥 <strong>Sert :</strong> {result.peopleServed} personnes</li>
                          <li>🥣 <strong>Volume Total Mélange :</strong> {result.totalVolume.toFixed(0)} ml</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>La recette de crêpes parfaites</h3>
              </div>
              <div className="info-section-body">
                <p>
                  La crêpe parfaite repose sur un ratio simple : 1 tasse de farine, 2 oeufs, 1 tasse de lait et une pincée de sel. Mais c'est la technique qui fait toute la différence.
                  La pâte doit reposer au minimum 30 minutes au réfrigérateur — ce temps permet au gluten de se détendre, ce qui donne des crêpes plus tendres et moins élastiques.
                  Cette calculatrice ajuste automatiquement toutes les quantités selon le nombre de crêpes que vous souhaitez préparer.
                </p>
                <ul>
                  <li>Farine tamisée : évite les grumeaux et donne une pâte fluide</li>
                  <li>Lait à température ambiante : s'incorpore mieux que le lait froid</li>
                  <li>Beurre fondu dans la pâte : évite d'avoir à graisser la poêle à chaque crêpe</li>
                  <li>Repos de la pâte : 30 min minimum, idéalement 1 heure</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Crêpes salées vs sucrées : les différences</h3>
              </div>
              <div className="info-section-body">
                <p>
                  En France, les crêpes sucrées (de Bretagne) sont faites à base de farine de blé ordinaire, tandis que les galettes salées (aussi bretonnes) utilisent de la farine
                  de sarrasin — aussi appelée blé noir. La farine de sarrasin n'a pas de gluten, ce qui rend les galettes plus fragiles mais avec un goût de noisette caractéristique.
                  Pour les crêpes sucrées, ajoutez une cuillère de sucre et de la vanille ou du rhum à votre pâte de base.
                </p>
                <ul>
                  <li>Crêpes sucrées : farine blanche + œufs + lait + beurre + sucre</li>
                  <li>Galettes salées : farine de sarrasin + eau + sel (+ 1 œuf pour la tenue)</li>
                  <li>Crêpes épaisses (style américain) : ajouter levure chimique pour le moelleux</li>
                  <li>Crêpes suzette : crêpes sucrées flambées au Grand Marnier avec sauce à l'orange</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Combien de crêpes par personne ?</h3>
              </div>
              <div className="info-section-body">
                <p>
                  En entrée ou en dessert léger : 2 à 3 crêpes par personne suffisent. En plat principal : comptez 4 à 6 crêpes garnies. Pour un goûter d'enfants : 3 crêpes par
                  enfant en général. La taille de la poêle détermine aussi la taille des crêpes — une poêle de 28 cm donne une crêpe d'environ 25-26 cm de diamètre après la
                  cuisson, ce qui est la taille standard pour un repas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PerfectPancakeCalculator;
